import { DropDownList } from '@progress/kendo-react-dropdowns'
import orderBy from 'lodash/orderBy'
import toPairs from 'lodash/toPairs'
import * as React from 'react'
import { connect } from 'react-redux'
import * as AppTypes from '../../../app/types'
import * as ReferenceTypes from '../../reference/types'
import * as PreviewNewsbrief from '../preview-newsbrief'
import * as ModalTypes from '../preview-newsbrief/types'
import * as NewsbriefTypes from '../types'
import * as NewsbriefUtils from '../utils'
import * as Actions from './actions'
import * as Constants from './constants'

type ReferenceTemplate = ReferenceTypes.TemplateReferenceData
interface Template {
  description: string,
  isSelected?: boolean,
  name: string,
}

interface WrappedEmailTemplateSummary {
  emailTemplates: NewsbriefTypes.ConfigurationRow[]
  selectedPartner: string,
}
interface ColorSummaryInterface {
  colors: NewsbriefTypes.ConfigurationRow[]
}

export type ColorSummary = ColorSummaryInterface
interface DispatchProps {
  updateTemplate: NewsbriefTypes.StateUpdateActionCreator,
  toggleModal: ModalTypes.ToggleModal,
  addEmail: NewsbriefTypes.StateUpdateActionCreator,
}
type Props = DispatchProps &
             WrappedEmailTemplateSummary &
             AppTypes.WrappedState &
             ColorSummary &
             ReferenceTypes.WrappedState

export const handleTemplateChange =
  (
    selectedTemplateName: string,
    selectedPartner: string,
    allTemplates: ReferenceTemplate[],
    selectedTemplate: NewsbriefTypes.ConfigurationRow,
    updateTemplate: NewsbriefTypes.StateUpdateActionCreator,
    addEmailTemplate: NewsbriefTypes.StateUpdateActionCreator,
  ) => {
    const templateFileName = allTemplates.find((t: ReferenceTemplate) => t.description === selectedTemplateName).name
    if (templateFileName) {
      if (!selectedTemplate.data.isDefault &&
          NewsbriefUtils.isSelectedPartner(selectedTemplate.data.partner_code, selectedPartner)) {
        updateTemplate({
          partnerCode: selectedPartner,
          property: 'value',
          rowId: selectedTemplate.rowId,
          value: templateFileName,
        })
      } else {
        addEmailTemplate({
          name: Constants.EMAIL_TEMPLATE,
          partnerCode: selectedPartner,
          property: 'value',
          rowId: selectedTemplate.rowId,
          value: templateFileName,
        })
      }
    }
}

export const availableTemplates =
  (currentTemplate: NewsbriefTypes.ConfigurationRow, allTemplates: ReferenceTemplate[]): Template[] => {
  const sharedTemplates: Template[] =
    orderBy(allTemplates.filter((t: ReferenceTemplate) => t.shared && t.name !== currentTemplate.data.value)
                .map((t: ReferenceTemplate) => ({
                  description: t.description,
                  isSelected: false,
                  name: t.name,
                })), ['description'])

  let selectedTemplates: Template[] =
    allTemplates.filter((t: ReferenceTemplate) => t.name === currentTemplate.data.value)
                .map((t: ReferenceTemplate) => ({
                  description: t.description,
                  isSelected: true,
                  name: t.name,
                }))
  if (selectedTemplates.length === 0) {
    selectedTemplates = [
      {
        description: currentTemplate.data.value,
        isSelected: true,
        name: currentTemplate.data.value,
      },
    ]
  }
  return selectedTemplates.concat(sharedTemplates)
}

export const EmailTemplatePicker = (props: Props) => {
  if (props.emailTemplates.length > 0) {

    const currentTemplate = NewsbriefUtils.findConfigWithDefault(
      Constants.EMAIL_TEMPLATE, props.selectedPartner, props.emailTemplates)

    const allTemplates = availableTemplates(currentTemplate, props.referenceData.templates)
    const selectedTemplate = allTemplates.filter((t: Template) => t.isSelected)[0]

    return <div key={currentTemplate.rowId}>
      <DropDownList
        className="dropdown-override width-50"
        onChange={(e) => handleTemplateChange(
          e.target.value,
          props.selectedPartner,
          props.referenceData.templates,
          currentTemplate,
          props.updateTemplate,
          props.addEmail)}
        data={allTemplates.map((t: Template) => t.description)}
        value={selectedTemplate.description} />
    </div>
  } else {
    return null
  }
}

type StateProps = NewsbriefTypes.WrappedState & AppTypes.WrappedState & ReferenceTypes.WrappedState
export const EmailTemplatePickerConnected = connect(
  ({ app, newsbriefConfigs, referenceData }: StateProps) =>
    ({
      app,
      colors:
        toPairs(newsbriefConfigs.colors)
        .map(([rowId, {data, editing}]: [string, NewsbriefTypes.Row<NewsbriefTypes.PayloadData>]) =>
          ({rowId, data, editing}))
        .filter(({rowId, data, editing}) =>
          !data.isDefault && data.is_active &&
          NewsbriefUtils.isSelectedPartner(data.partner_code, newsbriefConfigs.configState.selectedPartner)),
      emailTemplates:
          toPairs(newsbriefConfigs.emailTemplate)
          .map(([rowId, {data, editing}]: [string, NewsbriefTypes.Row<NewsbriefTypes.PayloadData>]) =>
            ({rowId, data, editing})),
      referenceData,
      selectedPartner: newsbriefConfigs.configState.selectedPartner,
    }),
      {
        addEmail: Actions.addEmailTemplate,
        toggleModal: (t: ModalTypes.Template, c: ModalTypes.CommunityIdentifier, l: ModalTypes.Content) =>
          PreviewNewsbrief.toggleModal(t, c, l),
        updateTemplate: Actions.updateTemplateField,
      },
)(EmailTemplatePicker)



// WEBPACK FOOTER //
// ./src/pages/newsbrief/email-template/component.tsx